import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { applyStepState } from "../../recoil/pageStep";
import useRecord from "../../api/hooks/recorder";
import {
  deviceListState,
  inputDeviceGroupState,
  isSettingModalOpenState,
  micState,
  selectedDeviceState,
  streamState,
} from "../../recoil/record";
import NoCameraDetected from "../modules/exam/NoCameraDetected";
import VolumeMeter from "../modules/record/VolumeMeter";
import DeviceSelectModal from "../modules/exam/DeviceSelectModal";
import FooterButtonGroup from "../modules/layout/FooterButtonGroup";
import useExamRoomActions from "../../api/hooks/admin/examRoom";
import { authState } from "../../recoil/auth";
import { speakLanguageToKorean } from "../../static";
import Header from "../modules/layout/Header";

const Connect = () => {
  const videoRef = useRef(null);

  const record = useRecord();
  const [stream, setStream] = useRecoilState(streamState);
  const setApplyStep = useSetRecoilState(applyStepState);
  const [testVisible, setTestVisible] = useState(true);
  const setIsSettingModalOpen = useSetRecoilState(isSettingModalOpenState);
  const [selectedDevice, setSelectedDevice] =
    useRecoilState(selectedDeviceState);
  const hasMicPermissions = useRecoilValue(micState);
  const [deviceList, setDeviceList] = useRecoilState(deviceListState);
  const [inputDeviceGroup, setInputDeviceGroup] = useRecoilState(
    inputDeviceGroupState
  );
  const [connectMicCheck, setConnectMicCheck] = useState(true);
  const auth = useRecoilValue(authState);
  // const room_type = auth?.data?.room_type;
  // const koreanTitle = speakLanguageToKorean(room_type);

  const { setLog } = useExamRoomActions();

  useEffect(() => {
    record.handleStreaming(selectedDevice);

    let audioDefaultId = null;
    let videoDefaultId = null;
    for (let i = 0; i < deviceList.length; i++) {
      if (selectedDevice.audio?.deviceId) {
        if (
          deviceList[i].deviceId === selectedDevice.audio.deviceId &&
          deviceList[i].kind === "audioinput"
        ) {
          audioDefaultId = deviceList[i].groupId;
          setConnectMicCheck(false);
        }
      }
      if (selectedDevice.video?.deviceId) {
        if (
          deviceList[i].deviceId === selectedDevice.video.deviceId &&
          deviceList[i].kind === "videoinput"
        ) {
          videoDefaultId = deviceList[i].groupId;
        }
      }
    }

    setInputDeviceGroup({ audio: audioDefaultId, video: videoDefaultId });

    // console.log("inputDeviceGroup :", inputDeviceGroup)
  }, [selectedDevice]);

  useEffect(() => {
    const setStream = async () => {
      videoRef.current.srcObject = stream;
    };
    setStream();
  }, [stream]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      setDeviceList(devices);
    });
  }, []);

  
  useEffect(() => {
    allowPermission();
  }, []);

  const allowPermission = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((stream) => {
        let firstAudio = null;
        let firstVideo = null;

        for (let i = 0; i < deviceList.length; i++) {
          if (
            deviceList[i].kind === "audioinput" &&
            deviceList[i].deviceId !== "default"
          ) {
            firstAudio = deviceList[i].deviceId;
            break;
          }
        }

        for (let i = 0; i < deviceList.length; i++) {
          if (deviceList[i].kind === "videoinput") {
            firstVideo = deviceList[i].deviceId;
            break;
          }
        }

        // if (!firstAudio) {
        //   alert("마이크 입력장치가 없습니다");
        //   return;
        // }

        setConnectMicCheck(false);

        setSelectedDevice({
          audio: {
            deviceId: firstAudio,
          },
          video: {

            deviceId: firstVideo,
          },
        });

        setStream(stream);
      })
      .catch(function (err) {
        if (err.name !== "NotFoundError") {
          alert("카메라 / 마이크 권한을 허용해 주세요");
        }
      });
  };

  return (
    // <div>
    //   <div>
    //     <div className="base-top flex">
    //       <div className="main_logo"></div>
    //     </div>
        
    //   </div>
    // </div>
    <div>
      <Header />
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              {/* <p className="title">{koreanTitle}</p> */}
              <p className="title">영어 말하기 평가</p>
            </div>
          </div>
          <div className="base-sec-sec connect-sec text-align-center">
            <NoCameraDetected />
            <div className="connect-txt">
              <p className="connect-title">카메라 · 마이크 테스트</p>
              <p className="connect-subtitle">
                카메라와 마이크가 정상적으로 설치/연결 되었는지 확인해주세요.
              </p>
            </div>
            <div className="camera-guide-box">
              <video
                muted
                autoPlay
                ref={videoRef}
                width="100%"
                height="100%"
              />
            </div>
            <div className="setting-a flex">
              <div className="empty"></div>
              <div className="gauge">
                <VolumeMeter />
                <p className="gauge-text">마이크 볼륨을 확인해 주세요.</p>
              </div>
              <div
                className="camera-mic-set-btn"
                onClick={() => setIsSettingModalOpen(true)}
              >
                설정
              </div>
            </div>
          </div>
          <DeviceSelectModal />
          <FooterButtonGroup
            prevOnClick={() => setApplyStep((old) => old - 1)}
            nextOnClick={() => {
              if (connectMicCheck) {
                alert("마이크 입력장치가 없습니다");
                return;
              }
              hasMicPermissions?.state === "granted"
                ? setApplyStep((old) => old + 1)
                : alert("권한을 승인해주세요.");
                // : console.log(hasMicPermissions);
            }}
            preSelect="selected"
            nextSelect="selected"
          />
        </div>
      </div>
    </div>
  );
};

export default Connect;
